export default "__VITE_ASSET__BlJgQgu8__"